<child-header [title]="'Migrate to NCE'" (closeEvent)="onNoClick()"></child-header>

<div mat-dialog-content>
  <!-- form -->
  <form [formGroup]="migrateToNCEForm" *ngIf="!loading && !resultMsg">

    <!-- info -->
    <div class="col-12 my-2">
      <span *ngIf="annuity?.annuityId">This action will migrate all legacy subscriptions to <span class="nce">NCE</span> under this tenant, this will take sometime to get fulfilled by Microsoft. Please be aware that this action cannot be cancelled.</span>
      <span *ngIf="!annuity?.annuityId">This action will migrate all legacy subscriptions to <span class="nce">NCE</span> for <b>ALL</b> the tenants under your reseller account, this will take sometime to get fulfilled by Microsoft. Please be aware that this action cannot be cancelled.</span>
    </div>

    <!-- tenant info -->
    <div class="col-10 my-2" *ngIf="annuity?.annuityId">
      <div>
        <span >
          <label class="highlight-text">Tenant Name:&nbsp;</label>{{ annuity?.endUserName }}
        </span>
      </div>
      <div>
        <span >
          <label class="highlight-text">Tenant ID:&nbsp;</label>{{ annuity?.annuityId }}
        </span>
      </div>
    </div>
  
    <!-- TERM DURATION-->
    <div class="col-6 my-2">
      <span class="highlight-text">Term: </span>
      <mat-form-field style="padding-left: 0px;">
        <mat-select
          formControlName="term"
          (selectionChange)="checkIfYearly($event)"
          placeholder="{{ migrateToNCEForm.get('term').value ? null : 'Please Select' }}"
          required
          >
          <mat-option value="P1M">
            Monthly
          </mat-option>
          <mat-option value="P1Y">
            Annual
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- Billing Freqency-->
    <div class="col-6 my-2">
      <span class="highlight-text">Billing Frequency: </span>
      <mat-form-field style="padding-left: 0px;">
        <mat-select
          formControlName="billingCycle"
          placeholder="{{ migrateToNCEForm.get('billingCycle').value ? null : 'Please Select' }}"
          required>
            <mat-option value="monthly">Monthly</mat-option>
            <!-- show if term is yearly -->
            <mat-option
              *ngIf="migrateToNCEForm.get('term').value === 'P1Y'"
              value="annual">Annual</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="col-12 my-2">
      <span>Note: New term duration will be started during this migration</span>
    </div>
  </form>

  <!-- spinner -->
  <div class="col-10 my-2" *ngIf="loading" style="margin: auto;">
    <mat-spinner style="margin: auto;" mode="indeterminate" diameter="20" >
    </mat-spinner>
  </div>

  <!-- result message -->
  <div *ngIf="resultMsg" >
    <span>{{ resultMsg }}</span>
  </div>
</div>

<div mat-dialog-actions  [ngClass]="{'wide-buttons ': !resultMsg}">
  <button mat-button *ngIf="!resultMsg" class="button button-red button-large button-left" (click)="onNoClick()">Cancel</button>
  <button mat-button class="button button-red button-large" (click)="confirm()" [disabled]="!migrateToNCEForm.valid">{{ resultMsg ? 'Ok' : 'Confirm' }}</button>
</div>